import { superAdminApi } from "../authService";
import {
  ApiResponse,
  PaginatedApiResponse,
  PaginationParams,
} from "../../types/api";

const RESOURCE = "/super-admin/webhook-logs";

export interface WebhookLogTenant {
  id: number;
  name: string;
}

export interface WebhookLog {
  id: number;
  tenant_id: number | null;
  tenant: WebhookLogTenant | null;
  provider_slug: string;
  capability: string | null;
  direction: "inbound" | "outbound" | string;
  event: string;
  payload?: Record<string, unknown> | unknown[] | null;
  http_status: number | null;
  external_event_id: string | null;
  error_message?: string | null;
  created_at: string;
  updated_at: string;
}

export interface WebhookLogListParams extends PaginationParams {
  provider_slug?: string;
  direction?: "inbound" | "outbound" | "";
  tenant_id?: number;
  http_status?: number;
}

export const getWebhookLogs = async (
  params?: WebhookLogListParams
): Promise<PaginatedApiResponse<WebhookLog>> => {
  const response = await superAdminApi.get<PaginatedApiResponse<WebhookLog>>(
    RESOURCE,
    { params }
  );

  return response.data;
};

export const getWebhookLog = async (
  id: number
): Promise<ApiResponse<WebhookLog>> => {
  const response = await superAdminApi.get<ApiResponse<WebhookLog>>(
    `${RESOURCE}/${id}`
  );

  return response.data;
};
